import React from 'react';
import Hero from '../components/Hero/Hero.jsx'; // путь может отличаться
import '../styles/Home.scss'; // если там есть доп. стили

function Home() {
  return (
    <div className="home">
      <Hero />
    </div>
  );
}

export default Home;
